// EXEMPT
import { IS_APP, IS_DEV } from "@/__main__/constants.mjs";
import { readData } from "@/__main__/get-data.mjs";
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import isRouteOverlay from "@/util/is-route-overlay.mjs";
import rangeBucket from "@/util/range-bucket.mjs";
import {
  getEnvironmentIdentifier,
  getFeatureIdentifier,
} from "@/util/use-ab-feature.mjs";

const MAIN_DOMAIN = { hostname: "blitz.gg" };
const ALT_DOMAINS = [
  {
    hostname: "agentselect.net",
    rollout: {
      US: 1,
      AE: 1,
      AR: 1,
      AT: 1,
      AU: 1,
      CA: 1,
      CZ: 1,
      DE: 1,
      GB: 1,
      MX: 1,
      NL: 1,
      NZ: 1,
      SA: 1,
      SG: 1,
    },
  },
  {
    hostname: "championselect.net",
    rollout: {
      US: 25,
      AE: 35,
      AR: 35,
      AT: 11,
      AU: 14,
      BR: 15,
      CA: 25,
      CH: 80,
      CL: 45,
      CZ: 11,
      DE: 20,
      ES: 30,
      GB: 30,
      HK: 15,
      JP: 6,
      KR: 10,
      MX: 70,
      NL: 30,
      NZ: 62,
      SA: 70,
      SG: 40,
      TR: 1,
    },
  },
  {
    hostname: "probuilds.net",
    rollout: {
      US: 73,
      AE: 60,
      AR: 60,
      AT: 67,
      AU: 71,
      BR: 80,
      CA: 71,
      CH: 18,
      CL: 8,
      CR: 1,
      CZ: 60,
      DE: 65,
      ES: 50,
      FR: 1,
      GB: 60,
      HK: 70,
      JP: 20,
      KR: 10,
      MX: 25,
      NL: 5,
      NZ: 35,
      SA: 10,
      SG: 50,
      TR: 3,
    },
  },
];

// figure out where to redirect domain...
//
// NOTE: this should probably be temporary. the problem with this approach
// is that it has to load the whole app first. a better approach would be
// to create a separate entry point just to read the country code and load
// that first.
(async () => {
  if (IS_DEV || !IS_APP || isRouteOverlay()) return;

  const res = await readData(["search", "regionData"]);
  const countryCode = res?.["ISO 3166-1 alpha-2"];

  // const uniqueId = new Date().toISOString().slice(0, 10);
  const { id } = await getEnvironmentIdentifier();
  const featureIdentifier = getFeatureIdentifier(id, "desktop-traffic");
  const featureIdent = featureIdentifier % 100;

  const useLatestUA = true;
  if (location.hostname === MAIN_DOMAIN.hostname) {
    updateUserAgent(useLatestUA);
  }

  const altDomainCountries = new Set(
    ALT_DOMAINS.flatMap((d) => Object.keys(d.rollout)),
  );
  if (altDomainCountries.has(countryCode)) {
    const domain = chooseDomain(featureIdent, countryCode);
    if (domain && location.hostname !== domain.hostname) {
      // eslint-disable-next-line no-console
      // console.log(`Redirecting to ${domain.hostname}`);
      if (domain?.rollout) await updateUserAgent(domain.rollout);
      const u = new URL(location);
      u.port = "";
      u.hostname = domain.hostname;
      u.protocol = "https:";
      location = u;
    }
  }
})();

function chooseDomain(featureIdent, countryCode) {
  let cumulativeRollout = 0;
  const domainsBucket = [];

  for (const domain of ALT_DOMAINS.filter(
    (domain) => domain.rollout[countryCode],
  )) {
    const rolloutPercentage = domain.rollout[countryCode];
    if (rolloutPercentage) {
      domainsBucket.push([cumulativeRollout, domain]);
      cumulativeRollout += rolloutPercentage;
    }
  }
  domainsBucket.push([cumulativeRollout, MAIN_DOMAIN]);

  const selectedDomain = rangeBucket(domainsBucket)[featureIdent];

  return {
    hostname: selectedDomain.hostname,
    rollout:
      selectedDomain === MAIN_DOMAIN
        ? 100 - cumulativeRollout
        : selectedDomain.rollout[countryCode],
  };
}

async function updateUserAgent(useLatestUserAgent) {
  const version = useLatestUserAgent ? "139.0.0.0" : "126.0.6478.127";

  const currentUserAgent = navigator.userAgent;
  const newUserAgent = currentUserAgent.replace(
    /Chrome\/\d+\.\d+\.\d+\.\d+/,
    `Chrome/${version}`,
  );

  if (newUserAgent !== currentUserAgent) {
    await blitzMessage(EVENTS.APP_SET_USERAGENT, newUserAgent);
  }
}
